import { computed } from "vue";
import { useStore } from "vuex";
import { useConfig, useLoading, useFilter, useSort, useVuexPageLimit, useDateFormat } from ".";
import { getVpnServerConnections } from "@/services/vpn-server";

export default function useVpnConnectedClients(serverIndex: number) {
  const store = useStore();
  const state = computed(() => store.state.vpnConnectedClients);
  const { SORT_NONE } = useConfig();
  const { setLoading } = useLoading();
  const { timezoneOffset } = useDateFormat();
  const moduleName = `vpnConnectedClients${serverIndex}`;

  const sortProps = computed(() => {
    return {
      commonName: SORT_NONE,
      connectedSince: SORT_NONE,
    };
  });
  const items = computed(() => state.value.items[serverIndex]);
  const setItems = (items: Record<string, any>[]) => store.commit(`vpnConnectedClients/SET_ITEMS`, { items, serverIndex });
  if (!items.value) {
    setItems([]);
  }
  const { totalPage, totalItem, take, takes, skip, currentPage, setTotalItem, setTotalPage, setLimit, setCurrentPage, resetPaginate } =
    useVuexPageLimit(moduleName);
  const { sortAttrs, sortAttrsValue, setSortColumnValue } = useSort(moduleName, sortProps.value, async () => {
    fetchData();
  });
  const sortState = store.state.sort.module["vpnConnectedClients"];
  const fetchSortProps = () => {
    for (const prop in sortProps.value) {
      if (prop === sortState?.sort_by) {
        sortProps.value[prop] = sortState?.sort_order || SORT_NONE;
      }
    }
  };
  const { filterAttrs, moduleAttrs, setFilter } = useFilter(moduleName);

  const fetchData = async () => {
    setLoading(true);
    setItems([]);
    try {
      const requestObj = {
        pageIndex: currentPage.value,
        pageSize: take.value,
        skip: skip.value,
        ...filterAttrs.value,
        ...sortAttrsValue.value,
        timezoneOffset,
      };
      const response = await getVpnServerConnections(serverIndex, requestObj);
      const { data, totalItems, totalPages } = response;
      setItems(data);
      setTotalItem(totalItems);
      setTotalPage(totalPages);
    } catch (error) {
      console.error("Failed to fetch VPN connections:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    // pagination
    items,
    totalPage,
    totalItem,
    take,
    takes,
    skip,
    currentPage,
    setTotalItem,
    setTotalPage,
    setItems,
    setLimit,
    setCurrentPage,
    resetPaginate,
    // sort
    sortAttrs,
    sortAttrsValue,
    sortProps,
    fetchSortProps,
    setSortColumnValue,
    // filter
    filterAttrs,
    moduleAttrs,
    setFilter,

    fetchData,
  };
}
